import {
  ActionType,
  IDepartmentList4DashboardResponse,
} from "models/dashboard/departmentList";

export const getDepartmentList4DashboardAction = () => {
  return {
    type: ActionType.GET_DEPARTMENT_LIST_4_DASHBOARD,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.GET_DEPARTMENT_LIST_4_DASHBOARD_ERROR,
    payload,
  };
};

export const handleSuccesAction = (
  payload: IDepartmentList4DashboardResponse
) => {
  return {
    type: ActionType.GET_DEPARTMENT_LIST_4_DASHBOARD_SUCCESS,
    payload,
  };
};
